import { Link } from "@inertiajs/react";
import { cn } from "@/lib/utils";

interface NavLinkProps {
  href: string;
  active?: boolean;
  mobile?: boolean;
  children: React.ReactNode;
}

export function NavLink({ href, active, mobile, children }: NavLinkProps) {
  return (
    <Link
      href={href}
      className={cn(
        "flex items-center gap-2 rounded-md px-3 py-2 text-sm transition",
        mobile && "flex-col gap-1 px-4 py-1.5 text-xs",
        active
          ? "bg-accent/15 text-accent-foreground"
          : "text-muted-foreground hover:bg-accent/10 hover:text-foreground"
      )}
    >
      {children}
    </Link>
  );
}
